<template>
  <div>
    <WdsHeading type="title2" class="tw-pb-4">{{ $t('Collaborators') }}</WdsHeading>
    <div class="card card-bg-secondary tw-p-4">
      <WdsStack direction-column>
        <WdsStack direction-row justify-space-between class="tw-pb-6">
          <WdsText
            :sub-text="$t('Selected staffing agencies can see and submit candidates for this job')"
          >
            {{ $t('Recruiters & staffing agencies') }}
          </WdsText>
          <JobShareRecruiters
            :job-id="jobObj.id"
            :is-published="jobObj.published"
            @contacts-updated="handleContactsUpdated"
          />
        </WdsStack>
        <WdsAlert success bordered>
          {{
            $t(
              'Invited collaborators are emailed a job description and invitation to submit candidates',
            )
          }}
        </WdsAlert>
      </WdsStack>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { WdsAlert, WdsHeading, WdsStack, WdsText } from '@worksome/wds-components'

import { FragmentType, useFragment } from '@/gql'
import { publicApi } from '@/app-bootstrapping/SetUpApollo'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

import { JobFragment } from '@/components/Job/graphql/fragments'
import JobShareRecruiters from '@/components/Job/Share/JobShareRecruiters.vue'

const props = defineProps<{
  job: FragmentType<typeof JobFragment>
}>()

const jobObj = ref(useFragment(JobFragment, props.job))

const getJob = () =>
  publicApi.readFragment({
    id: `Job:${jobObj.value.id}`,
    fragment: JobFragment,
  })

const handleContactsUpdated = () => {
  const job = getJob() as FragmentType<typeof JobFragment>
  jobObj.value = useFragment(JobFragment, job)
}
</script>
